export default __webpack_public_path__ + "static/media/ActivityProfile.37e1bb45.svg";